import { Heart } from "lucide-react";
import type { HeartParticle, HeartTone } from "../../hooks/use-live-reactions";

const TONE_CLASS: Record<HeartTone, string> = {
  rose: "text-rose-400",
  blush: "text-pink-300",
  crimson: "text-rose-500",
  petal: "text-rose-300",
};

/**
 * Instagram-style hearts rising on every like — sized in vmin so they read from
 * across a hall on a projector. Layered depth (near = big/sharp/bright, far =
 * small/blurred/dim) gives a parallax feel; each carries a soft rose glow and
 * removes itself when the `ss-heart-rise` animation ends. Decorative.
 */
export function FloatingHearts({
  hearts,
  onDone,
}: {
  hearts: HeartParticle[];
  onDone: (id: number) => void;
}) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-30" aria-hidden>
      {hearts.map((h) => (
        <div
          key={h.id}
          className="ss-heart absolute bottom-[5%]"
          style={
            {
              left: `${h.left}%`,
              "--sway": `${h.sway}vmin`,
              "--life": `${h.life}s`,
              "--peak": h.near ? 0.96 : 0.62,
              filter: h.near ? undefined : "blur(0.45vmin)",
            } as React.CSSProperties
          }
          onAnimationEnd={() => onDone(h.id)}
        >
          <Heart
            className={`${TONE_CLASS[h.tone]} drop-shadow-[0_0_2.2vmin_rgba(244,114,182,0.55)]`}
            style={{ width: `${h.size}vmin`, height: `${h.size}vmin` }}
            fill="currentColor"
            strokeWidth={0}
          />
        </div>
      ))}
    </div>
  );
}
